import axios from "../../api";

export type SavedSquad = {
  name: string;
  id: string;
};

export const getSquads = async () => {
  const res = await axios.get<SavedSquad[]>("/saved-squads");
  return res.data;
};
